import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getConversations } from '@api';

export const getCoreAgentConversationsSlice = createGetAsyncSlice({
	name: 'coreAgentConversations',
	receive: true,
	request: true,
	requestHandler: getConversations,
	retainDataOnRequest: true
});
